import { render, staticRenderFns } from "./newDetail.vue?vue&type=template&id=5f1e13d0&scoped=true"
import script from "./newDetail.vue?vue&type=script&lang=js"
export * from "./newDetail.vue?vue&type=script&lang=js"
import style0 from "./newDetail.vue?vue&type=style&index=0&id=5f1e13d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e13d0",
  null
  
)

export default component.exports